// extracted by mini-css-extract-plugin
module.exports = {"form_div":"App_form_div__2Vl00","verdict_div":"App_verdict_div__cNtad"};